import { render, staticRenderFns } from "./CFileLayout.vue?vue&type=template&id=29fa8a89&scoped=true&"
import script from "./CFileLayout.vue?vue&type=script&lang=ts&"
export * from "./CFileLayout.vue?vue&type=script&lang=ts&"
import style0 from "./CFileLayout.vue?vue&type=style&index=0&id=29fa8a89&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29fa8a89",
  null
  
)

export default component.exports